const enum SiteType {
    BUSINESS = "business",
    COJP = "cojp"
}

export default SiteType;
